// The invite doors' first answer, held until the six is submitted.
//
// Tom, 2026-08-11: "maybe the answer write doesn't have to happen when the
// user taps yes/no for that first question. maybe that just pre-fills the
// answer for when they complete the six and then when they submit that the
// answers are written."
//
// He is right, and it is a simplification rather than a trade. `writeAnswer`
// wrote the SAME two docs `submitDailySet` writes minutes later — so the tap
// was paying for a round trip whose only lasting effect was to make an
// abandoned answer durable. And a lone recorded vote from someone who never
// submitted is an anomaly in a game whose whole contract is submit-based:
// `awardSubmissionPoints` fires on the sixth vote, so that orphan paid nothing
// and counted in the crowd numbers anyway.
//
// Now the tap keeps the answer here, the ballot renders it already answered,
// and the ONE write at submit covers it with the rest. Fewer round trips at
// the moment the user is watching, and one write path instead of two.
//
// Scoped to the play day so a stash made before the 3 AM ET roll can never
// pre-fill the next day's ballot (root rule 12), and cleared on submit.

const KEY = 'ps_pending_hook_answer';

// `question` is the WHOLE question doc, not just its id, because a hook is not
// guaranteed to be one of today's six: the server picks it from the League's
// arena or the Predictor's category, and a Predictor share can name any live
// question via ?q=. When it isn't in the six, the ballot has no card to
// pre-fill and the answer would evaporate — so Play falls back to writing it
// on its own, and that write needs the question's fields (category, text,
// resolution date) to build the answer + vote docs.
export function stashHookAnswer(question, answer, playDay) {
  const questionId = question?.id;
  if (!questionId || typeof answer !== 'boolean' || !playDay) return;
  try {
    localStorage.setItem(KEY, JSON.stringify({ questionId, answer, playDay, question }));
  } catch {
    // Private mode — the answer is simply re-asked on the ballot, which is
    // the pre-2026-08-11 behaviour for anyone whose write failed anyway.
  }
}

/** `{ questionId, answer, question }` for TODAY, or null. A stash from another
 *  play day is dropped on read rather than left to rot. */
export function readHookAnswer(playDay) {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const d = JSON.parse(raw);
    if (!d?.questionId || typeof d.answer !== 'boolean') return null;
    if (d.playDay !== playDay) { localStorage.removeItem(KEY); return null; }
    return { questionId: d.questionId, answer: d.answer, question: d.question || null };
  } catch {
    return null;
  }
}

export function clearHookAnswer() {
  try { localStorage.removeItem(KEY); } catch { /* nothing to clear */ }
}
